type Point = { x: number; y: number }

/** Sample the arc once; the browser animates transforms without React frame updates. */
export function coinFlight(
  index: number,
  count: number,
  origin: Point,
  target: Point,
  spread: number
): Keyframe[] {
  const angle = (index / count) * Math.PI * 2 - Math.PI / 2
  const scatter = {
    x: origin.x + Math.cos(angle) * spread,
    y: origin.y + Math.sin(angle) * spread * 0.7,
  }
  const rotation = (index % 2 ? 1 : -1) * (140 + index * 31)
  const transform = (p: Point, scale: number, rotate: number) =>
    `translate(${p.x}px, ${p.y}px) translate(-50%, -50%) rotate(${rotate}deg) scale(${scale})`
  const frames: Keyframe[] = [
    { offset: 0, opacity: 0, transform: transform(origin, 0.15, -rotation) },
    {
      offset: 0.12,
      opacity: 1,
      transform: transform(
        {
          x: origin.x + (scatter.x - origin.x) * 0.55,
          y: origin.y + (scatter.y - origin.y) * 0.55,
        },
        1.2,
        -rotation * 0.5
      ),
    },
    { offset: 0.3, opacity: 1, transform: transform(scatter, 1, 0) },
    {
      offset: 0.4,
      opacity: 1,
      transform: transform({ ...scatter, y: scatter.y - 7 }, 1, 8),
    },
  ]
  const control = {
    x: scatter.x + (target.x - scatter.x) * 0.15 + Math.cos(angle) * spread * 0.7,
    y: Math.min(scatter.y, target.y) - Math.min(90, origin.y * 0.2),
  }
  for (let step = 1; step <= 16; step++) {
    const t = step / 16
    const eased = t * t
    const p = {
      x:
        (1 - eased) ** 2 * scatter.x +
        2 * (1 - eased) * eased * control.x +
        eased ** 2 * target.x,
      y:
        (1 - eased) ** 2 * (scatter.y - 7) +
        2 * (1 - eased) * eased * control.y +
        eased ** 2 * target.y,
    }
    frames.push({
      offset: 0.4 + t * 0.6,
      opacity: step === 16 ? 0 : 1,
      transform: transform(p, 1 - eased * 0.72, rotation * eased),
    })
  }
  return frames
}
